const COMMENT_API_BASE_URL = 'https://shopify-column-likes-comments-api-2.vercel.app';

function getEnvironment() {
    const hostname = window.location.hostname;
    if (hostname.includes('develop-maison-echelle')) {
        return 'test';
    }
    return 'production';
}

class CommentManager {
    constructor(containerId) {
        this.container = document.getElementById(containerId);
        if(!this.container) return;

        this.environment = getEnvironment();
        this.API_BASE = COMMENT_API_BASE_URL;

        this.articleId = this.container.getAttribute('data-article-id');
        this.customerInfo = {
            name: this.container.getAttribute('data-customer-name') || '',
            email: this.container.getAttribute('data-customer-email') || '',
            isLoggedIn: this.container.getAttribute('data-customer-logged-in') === 'true'
        };
        if (!this.articleId) {
            console.error('Article ID not found');
            return;
        }
        this.init();
    }

    async init() {
        this.render();
        await this.loadComments();
        this.attachEventListeners();
    }

    render() {
        this.container.innerHTML = `
            <div class="comments-section">
                <div id="comment-error" class="message"></div>
                <div id="comment-success" class="message"></div>

                <div class="comment-form">
                    ${this.customerInfo.isLoggedIn ? `
                        <h3>コメントを投稿</h3>
                        <form id="comment-form">
                            <textarea
                                id="comment-textarea"
                                placeholder="コメントを入力してください(140文字まで)"
                                maxlength="140"
                                required
                            ></textarea>

                            <button type="submit" id="comment-submit" class="comment-submit-btn">
                                投稿する
                            </button>
                        </form>
                    ` : `
                        <p style="text-align: center; color: #999; padding: 20px 0; font-size: 14px;">
                            コメントを投稿するには<a href="/account/login" style="color: #333; text-decoration: underline;">ログイン</a>が必要です
                        </p>
                    `}
                </div>

                <div id="comments-list" class="comments-list">
                    <p class="no-comments">読み込み中...</p>
                </div>
            </div>
        `;
    }

    attachEventListeners() {
        if (this.customerInfo.isLoggedIn) {
            const commentForm = document.getElementById('comment-form');
            if (commentForm) {
                commentForm.addEventListener('submit', (e) => {
                    e.preventDefault();
                    this.submitComment(commentForm);
                });
            }
        }
    }

    formatDate(dateString) {
        const date = new Date(dateString);
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        const hours = String(date.getHours()).padStart(2, '0');
        const minutes = String(date.getMinutes()).padStart(2, '0');
        return `${year}/${month}/${day} ${hours}:${minutes}`;
    }

    showError(message) {
        const errorElement = document.getElementById('comment-error');
        if(errorElement) {
            errorElement.textContent = message;
            errorElement.style.display = 'block';
            setTimeout(() => {
                errorElement.style.display = 'none';
            }, 5000);
        }
    }

    showSuccess(message) {
        const successElement = document.getElementById('comment-success');
        if (successElement) {
            successElement.textContent = message;
            successElement.style.display = 'block';
            setTimeout(() => {
                successElement.style.display = 'none';
            }, 3000);
        }
    }

    escapeHtml(text) {
        const div = document.createElement('div');
        div.textContent = text;
        return div.innerHTML;
    }

    async loadComments() {
        if (!this.articleId) return;

        try {
            const response = await fetch(
                `${this.API_BASE}/api/comments/list?article_id=${this.articleId}&environment=${this.environment}`
            );

            const data = await response.json();

            if(data.success) {
                this.renderComments(data.comments);
            } else {
                console.error('コメントの取得に失敗しました:', data.error);
            }
        } catch(error) {
            console.error('コメントの取得エラー:', error);
        }
    }

    renderComments(comments) {
        const commentsListContainer = document.getElementById('comments-list');
        if(!commentsListContainer) return;

        if(comments.length === 0) {
            commentsListContainer.innerHTML = '<p class="no-comments">まだコメントがありません</p>';
            return;
        }

        commentsListContainer.innerHTML = comments.map(comment => {
            const repliesHtml = comment.replies.map(reply => {
                return `
                    <div class="comment-reply">
                        <div class="comment-header">
                            <span class="comment-date">${this.formatDate(reply.created_at)}</span>
                        </div>
                        <p class="comment-content">${this.escapeHtml(reply.content)}</p>
                    </div>
                `;
            }).join('');

            return `
                <div class="comment-item" data-comment-id="${comment.id}">
                    <div class="comment-header">
                        <span class="comment-date">${this.formatDate(comment.created_at)}</span>
                    </div>
                    <p class="comment-content">${this.escapeHtml(comment.content)}</p>
                    ${this.customerInfo.isLoggedIn ? `
                        <button class="reply-button" data-comment-id="${comment.id}">返信する</button>
                        <div class="reply-form-container" id="reply-form-${comment.id}" style="display: none;"></div>
                    ` : ''}
                    ${repliesHtml}
                </div>
            `;
        }).join('');

        if (this.customerInfo.isLoggedIn) {
            this.attachReplyButtonListeners();
        }
    }

    attachReplyButtonListeners() {
        const replyButtons = document.querySelectorAll('.reply-button');
        replyButtons.forEach(button => {
            button.addEventListener('click', () => {
                const commentId = button.getAttribute('data-comment-id');
                this.toggleReplyForm(commentId);
            });
        });
    }

    toggleReplyForm(commentId) {
        const formContainer = document.getElementById(`reply-form-${commentId}`);
        if(!formContainer) return;

        if (formContainer.style.display === 'none') {
            formContainer.innerHTML = this.createReplyFormHtml();
            formContainer.style.display = 'block';

            const cancelButton = formContainer.querySelector('.reply-cancel');
            cancelButton.addEventListener('click', () => {
                formContainer.style.display = 'none';
                formContainer.innerHTML = '';
            });

            const replyForm = formContainer.querySelector('.reply-form');
            replyForm.addEventListener('submit', (e) => {
                e.preventDefault();
                this.submitReply(commentId, replyForm);
            });
        } else {
            formContainer.style.display = 'none';
            formContainer.innerHTML = '';
        }
    }

    createReplyFormHtml() {
        return `
            <form class="reply-form">
                <textarea 
                    class="reply-textarea" 
                    placeholder="返信を入力..." 
                    maxlength="140" 
                    required
                ></textarea>
                <div class="reply-actions">
                    <button type="button" class="reply-cancel">キャンセル</button>
                    <button type="submit" class="reply-submit">投稿する</button>
                </div>
            </form>
        `;
    }

    async submitReply(parentCommentId, form) {
        if(!this.customerInfo.isLoggedIn) {
            this.showError('コメントを投稿するにはログインが必要です');
            return;
        }

        const textarea = form.querySelector('.reply-textarea');
        const submitButton = form.querySelector('.reply-submit');

        const content = textarea.value.trim();

        if(!content) {
            this.showError('コメントを入力してください');
            return;
        }

        submitButton.disabled = true;
        submitButton.textContent = '投稿中...';

        try {
            const response = await fetch(`${this.API_BASE}/api/comments/post`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    article_id: this.articleId,
                    content: content,
                    customer_name: this.customerInfo.name,
                    customer_email: this.customerInfo.email,
                    age_group: null,
                    parent_comment_id: parentCommentId,
                    environment: this.environment
                })
            });

            const data = await response.json();

            if (data.success) {
                this.showSuccess('返信を投稿しました');
                form.closest('.reply-form-container').style.display = 'none';
                form.closest('.reply-form-container').innerHTML = '';
                await this.loadComments();
            } else {
                this.showError(data.error || '返信の投稿に失敗しました');
            }
        } catch (error) {
            console.error('返信投稿エラー:', error);
            this.showError('サーバーエラーが発生しました');
        } finally {
            submitButton.disabled = false;
            submitButton.textContent = '投稿する';
        }
    }

    async submitComment(form) {
        if (!this.customerInfo.isLoggedIn) {
            this.showError('コメントを投稿するにはログインが必要です');
            return;
        }

        const textarea = form.querySelector('#comment-textarea');
        const submitButton = form.querySelector('#comment-submit');

        const content = textarea.value.trim();

        if (!content) {
            this.showError('コメントを入力してください');
            return;
        }

        submitButton.disabled = true;
        submitButton.textContent = '投稿中...';

        try {
            const response = await fetch(`${this.API_BASE}/api/comments/post`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    article_id: this.articleId,
                    content: content,
                    customer_name: this.customerInfo.name,
                    customer_email: this.customerInfo.email,
                    age_group: null,
                    parent_comment_id: null,
                    environment: this.environment
                })
            });

            const data = await response.json();

            if (data.success) {
                this.showSuccess('コメントを投稿しました');
                textarea.value = '';
                await this.loadComments();
            } else {
                this.showError(data.error || 'コメントの投稿に失敗しました');
            }
        } catch (error) {
            console.error('コメント投稿エラー:', error);
            this.showError('サーバーエラーが発生しました');
        } finally {
            submitButton.disabled = false;
            submitButton.textContent = '投稿する';
        }
    }
}

document.addEventListener('DOMContentLoaded', () => {
    new CommentManager('comment-section');
});